import React from 'react'
import Link, { withPrefix } from 'gatsby-link'

//  Components
import Button from '../Button/Button.js'

//  Styles
import styles from './Downloads.module.scss';

const Downloads = ( props ) => (
  <ul className={ styles.downloads__list }>
    <li>
      <h3><strong>Download the 2019 State Scorecard as a PDF</strong></h3>
      <Button href={ withPrefix(`/files/Radley_State_Scorecard_2019.pdf`)} text="Download PDF" /></li>
    {/* <li>
      <h3><strong>Download the 2018 State Data as an EXCEL document</strong></h3>
      <Button href="/" text="Download Excel" /></li> */}
    <li>
      <h3><strong>Learn more about your state’s performance through our Data Center</strong></h3>
      <Button href="http://datacenter.commonwealthfund.org" text="Go to the Data Center" /></li>
  </ul>
)

export default Downloads


// WEBPACK FOOTER //
// ./src/components/Downloads/Downloads.js